"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isProfileSetting(object) {
    return checkProfileSetting(object).fulfilled;
}
exports.isProfileSetting = isProfileSetting;
function checkProfileSetting(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasObject("sortOptions", __1.hasChoice("sortBy", [
        __1.SortByType.ALPHABETICAL,
        __1.SortByType.CREATION_DATE,
        __1.SortByType.ID_NUMBER,
        __1.SortByType.CREATION_DATE,
        __1.SortByType.ORDER_NUMBER,
        __1.SortByType.LAST_EDITED,
        __1.SortByType.LAST_OPENED,
    ]), __1.hasChoice("orderBy", [__1.OrderByType.ASC, __1.OrderByType.DESC])), __1.hasChoice("notificationStatus", [__1.NotificationStatusType.SHOW, __1.NotificationStatusType.HIDE])).withOptions(options).explain();
}
exports.checkProfileSetting = checkProfileSetting;
//# sourceMappingURL=ProfileSetting.js.map